import { toast } from 'react-toastify'
import { Modal } from '../../customComponents/Modal'

interface Props<T> {
  item?: T
  deleteFunction: (id: number, isUpdate: boolean) => Promise<{ success: boolean, errors: string[] }>
  onClose: () => void
  onConfirm: () => void
  itemType: string
}

export const DeleteItemModal = <T extends { id: number, isUpdate: boolean }>(props: Props<T>): JSX.Element => {
  const handleDeleteItem = async (): Promise<void> => {
    if (props.item == null) {
      toast.error('Error Deleting Item')
      props.onClose()
      return
    }
    const { success, errors } = await props.deleteFunction(props.item.id, props.item.isUpdate)

    if (!success) {
      errors.forEach(e => toast.error(e))
      props.onClose()
      return
    }

    toast.success(`${props.itemType} Deleted`)
    props.onConfirm()
  }

  return <>
    <Modal
      open={true}
      onConfirm={handleDeleteItem}
      onClose={props.onClose}
      title='Are you sure?'
      cancelButtonText='No, Cancel'
      confirmButtonText='Yes, Delete'
      data-testid='confirmDeleteItemModal'
      bodyContent={'You are about to delete this item.  This action will prompt a review from the START team.  Are you sure you wish to continue?'}
      maxWidth='xs'
    />
  </>
}
